var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import CartOptionChoiceModel from "./CartOptionChoiceModel";
import { sortBy, findIndex, remove, forEach, concat, filter, reduce, map, cloneDeep, compact } from 'lodash';
var CartOptionModel = /** @class */ (function () {
    function CartOptionModel(data) {
        this.id = data.id;
        this.choices = [];
        if (data.choices) {
            this.choices = map(data.choices, function (choice) {
                if (choice['__mc'] === 'CartOptionChoiceModel') {
                    return new CartOptionChoiceModel(choice);
                }
                return null;
            });
            this.choices = compact(this.choices);
            this.choices = sortBy(this.choices, function (choice) {
                return choice.includedQuantity > 1;
            });
        }
        this.exclusive = data.exclusive;
        this.required = data.required;
        this.name = data.name;
        this.basePrice = data.basePrice;
        this.isDivisible = data.isDivisible;
        this.isMaster = data.isMaster || false;
        this.freeChoicesCount = data.freeChoicesCount || 0;
        this.baseChoicePriceDelta = +(data.baseChoicePriceDelta) || 0;
        this.resolveRequired(data);
        this.__mc = 'CartOptionModel';
    }
    CartOptionModel.prototype.resolveRequired = function (data) {
        if (this.choices.length !== 0) {
            return;
        }
        if (this.required === true) {
            var requiredChoice_1 = null;
            data.choices.forEach(function (choice) {
                if (choice.selected) {
                    requiredChoice_1 = choice;
                }
            });
            if (requiredChoice_1 === null) {
                return;
            }
            requiredChoice_1 = new CartOptionChoiceModel(requiredChoice_1);
            this.addChoice(requiredChoice_1);
        }
    };
    CartOptionModel.prototype.findChoice = function (choice) {
        var choiceIndex = findIndex(this.choices, function (choiceModel) {
            return choice.id === choiceModel.id;
        });
        if (choiceIndex !== -1) {
            choice = this.choices[choiceIndex];
        }
        else {
            choice.quantity = 0;
        }
        return choice;
    };
    CartOptionModel.prototype.getExistingChoice = function (choice) {
        for (var _i = 0, _a = this.choices; _i < _a.length; _i++) {
            var choiceModel = _a[_i];
            if (choice.id === choiceModel.id) {
                return choiceModel;
            }
        }
        return null;
    };
    CartOptionModel.prototype.addChoice = function (choice) {
        if (this.exclusive && !this.isDivisible) {
            this.choices = [];
        }
        choice = this.findChoice(choice);
        if (choice.quantity === 0) {
            this.choices.push(choice);
        }
        choice.quantity++;
        choice.quantity = Math.min(choice.quantity, choice.maxQuantity);
        return this;
    };
    CartOptionModel.prototype.removeChoice = function (choice) {
        this.choices.forEach(function (choiceModel) {
            if (choice.id === choiceModel.id) {
                choiceModel.quantity--;
            }
        });
        this.choices = remove(this.choices, function (choiceModel) {
            var includedQuantity = choiceModel.includedQuantity;
            var quantity = choiceModel.quantity;
            var included = false;
            if (includedQuantity) {
                included = (quantity < includedQuantity);
            }
            return quantity > 0 || included;
        });
    };
    CartOptionModel.prototype.updateChoice = function (choice) {
        if (this.exclusive && this.isDivisible) {
            if (choice.siblingId === "0") {
                this.choices = [];
                this.choices.push(choice);
            }
            else if (this.choices.length) {
                // remove "0" choice & equal siblingId
                this.choices = this.choices.filter(function (optionChoice) {
                    if (optionChoice.siblingId !== "0" && optionChoice.siblingId !== choice.siblingId) {
                        return true;
                    }
                });
                this.choices.push(choice);
            }
        }
        else {
            var index = findIndex(this.choices, function (choiceModel) {
                return choiceModel.id === choice.id;
            });
            this.choices.splice(index, 1, choice);
        }
    };
    CartOptionModel.prototype.combineChoices = function (choices) {
        this.choices = concat(this.choices, choices);
        return this;
    };
    CartOptionModel.prototype.siblingOptionFilter = function (siblingId) {
        this.choices = this.getChoicesForSibling(siblingId);
        return this;
    };
    CartOptionModel.prototype.countNonIncludedChoices = function () {
        var count = 0;
        var whole = this.getNonIncludedChoiceCountForSibling('0');
        var leftSide = this.getNonIncludedChoiceCountForSibling('1') + whole;
        var rightSide = this.getNonIncludedChoiceCountForSibling('2') + whole;
        count = Math.max(leftSide, rightSide, whole);
        return count;
    };
    CartOptionModel.prototype.getNonIncludedChoiceCountForSibling = function (siblingId) {
        var choices = this.getChoicesForSibling(siblingId);
        var count = reduce(choices, function (accumulator, choice) {
            var count = choice.quantity - choice.includedQuantity;
            return accumulator + count;
        }, 0);
        return count;
    };
    CartOptionModel.prototype.getChoicesForSibling = function (siblingId) {
        var siblingChoices = this.choices.filter(function (choice) {
            return (choice.siblingId === siblingId);
        });
        return siblingChoices;
    };
    CartOptionModel.prototype.getPrice = function () {
        return this.getPriceForChoices(this.choices);
    };
    CartOptionModel.prototype.getPriceForSibling = function (siblingId) {
        var choices = this.getChoicesForSibling(siblingId);
        return this.getPriceForChoices(choices);
    };
    CartOptionModel.prototype.hasSiblings = function () {
        for (var _i = 0, _a = this.choices; _i < _a.length; _i++) {
            var choice = _a[_i];
            if (choice.siblingId !== "0") {
                return true;
            }
        }
        return false;
    };
    CartOptionModel.prototype.getPriceForChoices = function (choices) {
        var deltas = [];
        var freeChoices = this.freeChoicesCount;
        choices.forEach(function (c) {
            var choice = {
                price: c.price,
                id: c.id,
                free: c.freeChoice,
                name: c.name,
                included: false,
                selected: c.selected,
            };
            if (c.mutableQuantity) {
                var qty = c.quantity;
                var includedQty = c.includedQuantity || 0;
                for (var i = 0; i < qty; i++) {
                    var choiceClone = cloneDeep(choice);
                    choiceClone.included = false;
                    if (includedQty > 0) {
                        choiceClone.included = true;
                        includedQty--;
                    }
                    //  located here bc online store uses qty 1, but on export, qty = 0.
                    if (c.fractionalQuantity && !c.includedQuantity) {
                        var div = c.fractionalQuantity / c.maxFractionalQuantity;
                        choiceClone.price = Math.round(c.price * div);
                    }
                    if (freeChoices > 0) {
                        freeChoices--;
                        choiceClone.price = 0;
                    }
                    deltas.push(choiceClone);
                }
            }
            else {
                // push price if there is a quantity
                if (freeChoices > 0) {
                    freeChoices--;
                    choice.price = 0;
                }
                deltas.push(__assign({}, choice, { included: !!c.includedQuantity }));
            }
        });
        return deltas;
    };
    CartOptionModel.prototype.exportModel = function (itemHasException) {
        if (itemHasException === void 0) { itemHasException = false; }
        var isMaster = this.isMaster;
        var freeChoiceCount = this.freeChoicesCount || 0;
        var exportedChoices = this.choices.map(function (choice) {
            if (choice.freeChoice) {
                freeChoiceCount += choice.freeChoice;
            }
            if (choice && isMaster) {
                choice.hasMasterException = true;
            }
            return choice.exportModel();
        });
        exportedChoices = filter(exportedChoices, function (choice) {
            return choice !== null;
        });
        var optionBasePrice = this.basePrice;
        return {
            option_id: this.id,
            base_price: optionBasePrice,
            free_choices_count: freeChoiceCount,
            name: this.name,
            choices: exportedChoices,
            exclusive: this.exclusive,
            required: this.required,
        };
    };
    CartOptionModel.prototype.handleChoices = function (apiChoices, storeOption, siblingId) {
        var _this = this;
        if (siblingId === void 0) { siblingId = "0"; }
        apiChoices.forEach(function (choice) {
            var storeChoice = storeOption.getExistingChoice(choice);
            var currentChoice = null;
            // if choice exists on item, don't add again
            if (siblingId !== "0") {
                currentChoice = _this.getExistingChoice(__assign({}, choice, { id: choice.choice_id }));
            }
            // over ride some store choices
            // only add if new choice or applies to one side
            if (siblingId !== "0" && !currentChoice || siblingId === "0") {
                var qty = choice.qty || 0;
                var includedQty = (choice.hasOwnProperty("included_qty")) ? choice.included_qty : 0;
                // its required, should have 1
                if (_this.required && !qty) {
                    qty = 1;
                    if (typeof choice.included_qty === "undefined" && (_this.exclusive && _this.required && !choice.is_user_set)) {
                        includedQty = 1;
                    }
                }
                else if (choice.is_user_set && !choice.selected && !qty) {
                    qty = 0;
                    includedQty = 1;
                }
                _this.choices.push(new CartOptionChoiceModel(__assign({}, storeChoice, choice, { quantity: qty, selected: choice.selected, includedQuantity: includedQty, priceDelta: storeChoice.priceDelta || choice.price_delta, siblingId: siblingId })));
            }
            else if (siblingId !== "0" && currentChoice) {
                // choice exists elsewhere, set to 0
                currentChoice.setSibling("0");
            }
        });
    };
    CartOptionModel.prototype.updateChoices = function (choicesOverwrite) {
        forEach(this.choices, function (choice) {
            forEach(choicesOverwrite, function (overwrite) {
                if (choice.id === overwrite.gcid) {
                    choice.price = overwrite.price_delta || overwrite.priceDelta;
                    choice.includedChoice = overwrite.included;
                }
            });
        });
    };
    CartOptionModel.prototype.recentScriptHydrator = function (data) {
        this.id = data.option_id || data.id;
        this.exclusive = data.exclusive;
        this.required = data.required;
        this.name = data.name;
        this.basePrice = parseInt(data.basePrice) || 0;
        this.isDivisible = data.isDivisible;
        this.choices = [];
        this.__mc = 'CartOptionModel';
    };
    return CartOptionModel;
}());
export default CartOptionModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/CartOptionModel.ts
// module id = iLRP
// module chunks = 18